<div (mouseenter)="onMouseEnter.emit()" (mouseleave)="onMouseLeave.emit()" class="tooltip"
     [style.left]="left + 'px'" [style.top]="top + 'px'" >
  <div class="tooltip-text">{{tooltip}}</div>
  <div class="tooltip-action-button-wrapper">
    <button class="tooltip-action-button" (click)="onActionButtonClicked.emit()">{{actionButtonName}}</button>
  </div>
</div>